// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { VZNetfilterStatus } from 'common/api/resources/ComputeResourceVm';
import { Translate } from '@plesk/ui-library';
import {
    ISegmentedControlProps,
    SegmentedControl,
} from 'common/components/SegmentedControl/SegmentedControl';

export interface IVZNetfilterStatusSegmentedControlProps  extends Pick<ISegmentedControlProps<VZNetfilterStatus>, 'withConfirmation' | 'onChange'> {
    disabled?: boolean;
    value: VZNetfilterStatus;
}

const VZNetfilterStatusSegmentedControl: React.FC<IVZNetfilterStatusSegmentedControlProps> = ({
    disabled = false,
    value,
    ...rest
}) => {
    const buttons = Object.keys(VZNetfilterStatus).map(status => {
        const buttonValue = VZNetfilterStatus[status];
        let title = buttonValue.charAt(0).toUpperCase() + buttonValue.slice(1);

        return ({
            title,
            value: buttonValue,
            disabled: disabled || value === buttonValue,
            tooltip: <Translate content={tooltips[buttonValue]}/>,
        });
    });

    return (
        <SegmentedControl
            buttons={buttons}
            confirmationPopoverTranslations={{
                title: <Translate content="components.vzNetfilterStatusSegmentedControl.confirmationPopoverTitle"/>,
                button: <Translate content="change"/>,
                text: <Translate content="components.vzNetfilterStatusSegmentedControl.confirmText" />,
            }}
            {...rest}
            selected={value}
        />
    );
};

const tooltips = {
    [VZNetfilterStatus.DISABLED]: 'components.vzNetfilterStatusSegmentedControl.tooltips.disabled',
    [VZNetfilterStatus.STATELESS]: 'components.vzNetfilterStatusSegmentedControl.tooltips.stateless',
    [VZNetfilterStatus.STATEFUL]: 'components.vzNetfilterStatusSegmentedControl.tooltips.stateful',
    [VZNetfilterStatus.FULL]: 'components.vzNetfilterStatusSegmentedControl.tooltips.full',
};

export default VZNetfilterStatusSegmentedControl;